<template>
  <div>
    <!-- <pre>{{ orderFromRoute }}</pre> -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="invoiceName"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
      
    >
      <section slot="pdf-content">
        <Printer :order="selectedOrder" v-if="selectedOrder" />
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import Printer from './Printer.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Printer,
    VueHtml2pdf,
  },
  data() {
    return {
      selectedOrder: null,
      invoiceName: "",
    };
  },
  computed: {
    ...mapState(['userOrders', 'user']),
    usOrders() {
      return this.userOrders.filter(o => o.items && o.items.length && o.items[0] !== null);
    },
    orderFromRoute() {
      const orderId = this.$route.params.order;
      return this.usOrders.find(order => order._id.toString() === orderId);
    }
  },
  methods: {
    customergeneratePdf(order) {
      this.selectedOrder = order;
      this.invoiceName = 'invoice-'+order.invoiceNumber || `invoice-${order._id}`;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.html2Pdf.generatePdf();
        }, 1000);
      });
    }
  },
  async mounted() {
    if (!this.userOrders || !this.userOrders.length) {
      await this.$store.dispatch('getOrdersUser');
    }
    if (this.orderFromRoute) {
      this.customergeneratePdf(this.orderFromRoute);
    }
  },
  watch: {
    userOrders(newVal) {
      if (newVal.length && this.orderFromRoute) {
        this.customergeneratePdf(this.orderFromRoute);
      }
    }
  }
};
</script>
